import { render, staticRenderFns } from "./BarConsultationsISTByExamensComplementaire.vue?vue&type=template&id=5a40cccf&"
import script from "./BarConsultationsISTByExamensComplementaire.vue?vue&type=script&lang=ts&"
export * from "./BarConsultationsISTByExamensComplementaire.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports